import React, { useEffect } from 'react'

import { useRetorikStore } from '../Contexts/RetorikContext'
import { useSpeechStore } from '../Contexts/SpeechContext'
import { useViewStore } from '../Contexts/ViewContext'
import { useActivityStore } from '../Contexts/ActivityContext'
import { useUtilsStore } from '../Contexts/UtilsContext'

import { CurrentSubView, Mode, Routes } from '../../models/enums'

import HomeView from '../Views/HomeView'
import NewsView from '../Views/NewsView'
import WarningBeforeNewsView from '../Views/WarningBeforeNewsView'

interface RetorikRouterProps {
  externalComponents?: Array<{ name: string; component: JSX.Element }>
}

const RetorikRouter = (props: RetorikRouterProps): JSX.Element => {
  const isUsedOnBorne = useRetorikStore((state) => state.configuration.isUsedOnBorne)
  const mode = useSpeechStore((state) => state.mode)
  const route = useViewStore((state) => state.route)
  const setRoute = useViewStore((state) => state.actions.setRoute)
  const lastBotEvent = useActivityStore((state) => state.lastBotEventActivity)
  const setCurrentSubView = useUtilsStore((state) => state.actions.setCurrentSubView)

  useEffect(() => {
    if (lastBotEvent) {
      switch (lastBotEvent.name) {
        case 'news.ShowFlashInfo':
          setRoute(Routes.News)
          break
        case 'weather.ShowWeather':
          setCurrentSubView(CurrentSubView.weather)
          break
        default:
          break
      }
    }
  }, [lastBotEvent])

  return (
    <React.Fragment>
      {route === Routes.Home && <HomeView {...props} />}
      {route === Routes.News && (mode === Mode.vocal || !!isUsedOnBorne ? <NewsView /> : <WarningBeforeNewsView />)}
    </React.Fragment>
  )
}

export default RetorikRouter
